export const IsMobile = (resolution) => {
	if (resolution <= 768) return true;
	return false;
};
